import { gql } from '@apollo/client'

const CREATE_COMMAND = gql`
  mutation createCommand(
    $clientId: UUID
    $clientName: String!
    $contactName: String
    $contactPhone: String
    $comment: String
    $constructionSiteId: UUID
    $address: String
    $city: String
    $dateDelivery: Datetime
    $createdBy: UUID!
    $status: String
  ) {
    createCommand(
      input: {
        command: {
          clientId: $clientId
          clientName: $clientName
          contactName: $contactName
          contactPhone: $contactPhone
          comment: $comment
          constructionSiteId: $constructionSiteId
          address: $address
          city: $city
          dateDelivery: $dateDelivery
          createdBy: $createdBy
          status: $status
        }
      }
    ) {
      command {
        id
      }
    }
  }
`

const UPDATE_COMMAND = gql`
  mutation updateCommand(
    $id: UUID!
    $clientId: UUID
    $clientName: String!
    $contactName: String
    $contactPhone: String
    $comment: String
    $constructionSiteId: UUID
    $address: String
    $city: String
    $dateDelivery: Datetime
    $status: String
  ) {
    updateCommand(
      input: {
        patch: {
          clientId: $clientId
          clientName: $clientName
          contactName: $contactName
          contactPhone: $contactPhone
          comment: $comment
          constructionSiteId: $constructionSiteId
          address: $address
          city: $city
          dateDelivery: $dateDelivery
          status: $status
        }
        id: $id
      }
    ) {
      clientMutationId
    }
  }
`

const CREATE_COMMAND_MATERIAL = gql`
  mutation createCommandMaterial($commandId: UUID!, $materialId: UUID!, $quantity: BigFloat!) {
    createCommandMaterial(
      input: {
        commandMaterial: { commandId: $commandId, materialId: $materialId, quantity: $quantity }
      }
    ) {
      clientMutationId
    }
  }
`

const UPDATE_COMMAND_MATERIAL = gql`
  mutation updateCommandMaterial($id: UUID!, $materialId: UUID!, $quantity: BigFloat!) {
    updateCommandMaterial(
      input: { patch: { materialId: $materialId, quantity: $quantity }, id: $id }
    ) {
      clientMutationId
    }
  }
`

const DELETE_COMMAND_MATERIAL = gql`
  mutation deleteCommandMaterial($id: UUID!) {
    deleteCommandMaterial(input: { id: $id }) {
      clientMutationId
    }
  }
`

const COMMANDS = gql`
  query commands(
    $first: Int,
    $after: Cursor,
    $before: Cursor,
    $last: Int,
    $clientId: UUIDFilter
    $status: StringFilter
    $startDate: Datetime,
    $endDate: Datetime,
    $city: StringFilter
  ) {
    commands(
      orderBy: CREATED_AT_DESC,
      first: $first,
      after: $after,
      before: $before,
      last: $last,
      filter: {
        clientId: $clientId
        status: $status
        createdAt: { greaterThan: $startDate, lessThan: $endDate },
        city: $city
      }
    ) {
      edges {
        node {
          address
          city
          clientId
          commandNumber
          constructionSiteId
          comment
          contactName
          contactPhone
          createdAt
          createdBy
          dateDelivery
          id
          nodeId
          status
          clientName
          constructionSite {
            address
            city
            code
            postcode
          }
          client {
            displayName
          }
          userByCreatedBy {
            firstname
            lastname
          }
          commandMaterials {
            edges {
              node {
                material {
                  id
                  description
                  internalId
                  measureUnitByBaseMeasureUnitCode {
                    abbr
                  }
                  productCategoryByIdProductCategory {
                    family
                  }
                }
                id
                quantity
              }
            }
          }
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
      totalCount
    }
  }
`

const COMMAND_BY_ID = gql`
  query commandById($id: UUID!) {
    command(id: $id) {
      address
      city
      clientId
      commandNumber
      constructionSiteId
      comment
      contactName
      contactPhone
      createdAt
      createdBy
      dateDelivery
      id
      nodeId
      status
      clientName
      constructionSite {
        address
        city
        code
        postcode
      }
      client {
        displayName
      }
      userByCreatedBy {
        firstname
        lastname
      }
      commandMaterials {
        edges {
          node {
            material {
              id
              description
              internalId
              measureUnitByBaseMeasureUnitCode {
                abbr
              }
              productCategoryByIdProductCategory {
                family
              }
            }
            id
            commandId
            quantity
          }
        }
      }
    }
  }
`

export default {
  CREATE_COMMAND,
  UPDATE_COMMAND,
  CREATE_COMMAND_MATERIAL,
  UPDATE_COMMAND_MATERIAL,
  DELETE_COMMAND_MATERIAL,
  COMMANDS,
  COMMAND_BY_ID,
}